import BaseApi from '../baseApi';

export default class OnboardingApi extends BaseApi {
  constructor(obj) {
    obj = obj || {};
    super(obj);
  }

  getStatus() {
    return this.api.get('/onboarding-checklist/status');
  }

  completeStep(stepId) {
    return this.api.post(`/onboarding-checklist/${stepId}/complete`);
  }

  dismiss() {
    return this.api.post('/onboarding-checklist/dismiss');
  }

  inviteUser(data) {
    return this.api.post('/users/invite', data);
  }

  getInvitedUsers() {
    return this.api.get('/users/invited');
  }
}
